import BaseCrudRepository from '@/repositories/BaseCrudRepository';
import HttpClient from '@/util/http/HttpClient';
import ProductInventory from '@/repositories/data/webshop/ProductInventory';

export default class ProductInventoryRepository extends BaseCrudRepository<number, ProductInventory, ProductInventory> {
    constructor(client: HttpClient) {
        super(client, 'rest/admin/product-inventory/');
    }
}
